import React, { Component } from "react";
import format from "date-fns/format";
import "react-day-picker/dist/style.css";
import Timepicker from "react-time-picker";
import ResizeObserver from "resize-observer-polyfill";
import { BloxButton } from "styled_components/Common/BloxButton";
import { ClientData } from "services/clientData";
import { DayPickerReact } from "styled_components/Common/DayPicker";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const Arrow = `${CDN_URL}common/icons-arrow-circle.svg`;

class DateTimePicker extends Component {
  constructor(props) {
    super(props);

    this.myObserver = null;
    this.state = {
      selectedDay: null,
      selectedTimeValid: true,
      daySelected: false,
      time: "9:00",
      isOpen: true,
      error: false,
      clockRadius: 70,
      clockSize: 160,
      datetime: "",
      value: "",
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const { time } = this.props;
    if (time) {
      //this.checkValidTime(time);
      this.setState({ time });
    }
  }

  repositionTimepickerBackground = () => {
    const wrapper = document.querySelector(
      ".dcblox-date-time-picker-wrapper.time"
    );
    const svg = document.querySelector(".timepicker svg");
    const el = document.querySelector(".shadow-img");

    if (svg && wrapper && el) {
      // Re-position element...
      const xOffset =
        svg.getBoundingClientRect().left -
        wrapper.getBoundingClientRect().left -
        10;
      const yOffset =
        svg.getBoundingClientRect().top -
        wrapper.getBoundingClientRect().top -
        10;
      const { width } = svg.getBoundingClientRect();
      const height =
        ClientData.getBrowser() === "IE"
          ? width
          : svg.getBoundingClientRect().height;

      el.setAttribute(
        "style",
        `top: ${yOffset}px; left: ${xOffset}px; width: ${
          width + 20
        }px; height: ${height + 20}px`
      );
    }
  };

  componentDidUpdate() {
    const { daySelected } = this.state;

    if (daySelected) {
      this.repositionTimepickerBackground();
      if (!this.myObserver) {
        this.myObserver = new ResizeObserver((entries) => {
          entries.forEach(() => {
            this.repositionTimepickerBackground();
          });
        });

        setTimeout(() => {
          const wrapper = document.querySelector(
            `.dcblox-date-time-picker-wrapper .timepicker`
          );
          if (wrapper) {
            this.myObserver.observe(wrapper);
          }
        }, 300);
      }
    }
  }

  handleDayClick = (days) => {
    const { callback } = this.props;

    if (callback) {
      callback(days);
    }
    this.setState({ selectedDay: days });
    //this.daySelected(days);
  };

  daySelected = () => {
    this.setState({ daySelected: true });
  };

  timeSelected = (value) => {
    const { finishedCallback } = this.props;

    if (finishedCallback) {
      finishedCallback(value);
    }
  };
  checkValidTime = (value) => {
    const time = format(new Date(value), "HH:mm");
    const hour = time.getHours();
    const minute = time.getMinutes();
    if (
      hour === 9 ||
      hour === 10 ||
      hour === 11 ||
      hour === 12 ||
      hour === 13 ||
      hour === 14 ||
      hour === 15 ||
      (hour === 16 && minute <= 45)
    ) {
      this.setState({ error: false });
      return false;
    } else {
      this.setState({ error: true });
      return true;
    }
  };

  backToDatePicker = () => {
    this.setState({ daySelected: "" });
  };

  onChange(value) {
    this.checkValidTime(value);
    this.setState({ value });
  }

  render() {
    const { show, displayDate, breakpoint, inputs, closeModal } = this.props;
    const { daySelected, error, value } = this.state;

    return (
      <>
        {show && !daySelected && (
          <div className="dcblox-date-time-picker-wrapper">
            <DayPickerReact
              setSelectedDay={this.handleDayClick}
              closeModal={closeModal}
              breakpoint={breakpoint}
              inputs={inputs}
            />
          </div>
        )}
        {show && daySelected && (
          <div className="dcblox-date-time-picker-wrapper time">
            <div className="top-row">
              <div className="back-arrow" onClick={this.backToDatePicker}>
                <img src={Arrow} />
              </div>
              <div className="display-date">{displayDate}</div>
            </div>
            <div className="time-picker">
              <Timepicker
                onChange={this.onChange}
                value={value}
                format="h:mm a"
                isOpen={true}
                autoFocus={true}
                renderNumbers={true}
                renderMinuteMarks={false}
                secondHandWidth={2}
                secondHandOppositeLength={0}
                minuteHandOppositeLength={0}
                minuteHandWidth={4}
                hourHandOppositeLength={0}
                hourHandWidth={4}
                disableClock={true}
                clearIcon={null}
                minutePlaceholder={"--"}
                hourPlaceholder={"-"}
              />
            </div>
            {error && (
              <div className="error">
                Use the hour and minute digit indicators to select a time
                between 9:00AM and 4:45PM
              </div>
            )}
            <div className="done-button">
              <BloxButton
                title="DONE"
                enabled={!error}
                customClass="blox-button"
                onClick={() => this.timeSelected(value)}
              />
            </div>
            {/* <div className='shadow-img'>
							<img src={Shadow} className='shadow-img-asset' />
						</div> */}
            {/* <div className='angle-img'>
							<img src={backgroundAngle} className='background-angle-asset' />
						</div> */}
          </div>
        )}
      </>
    );
  }
}

export default DateTimePicker;
